import React, { useState } from 'react';

const LoginForm = ({ onLogin, onForgotPassword }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(username, password);
  };

  return (
    <div className="w-full max-w-md mx-auto bg-white rounded-xl shadow-2xl overflow-hidden">
      <div className="bg-gradient-to-r from-blue-600 to-blue-400 py-6 px-8"> {/* Increased padding */}
        <h2 className="text-2xl font-bold text-white text-center">Bienvenido de Nuevo</h2> {/* Centered text */}
      </div>
      <form onSubmit={handleSubmit} className="p-8 space-y-6"> {/* Increased padding */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Usuario o Correo</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all placeholder-gray-400" // Added placeholder style
            placeholder="Ingresa tu usuario o correo"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Contraseña</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all placeholder-gray-400" // Added placeholder style
            placeholder="Ingresa tu contraseña"
            required
          />
        </div>
        <button
          type="submit"
          className="w-full bg-gradient-to-r from-blue-600 to-blue-400 text-white py-3 px-4 rounded-lg hover:from-blue-700 hover:to-blue-500 transition-all shadow-md font-semibold" // Added font-semibold
        >
          Iniciar sesión
        </button>
         <button
            type="button"
            onClick={onForgotPassword}
            className="w-full text-center text-sm text-blue-600 hover:underline mt-4" // Added margin top
          >
            ¿Olvidaste tu contraseña?
          </button>
      </form>
      <div className="px-8 py-4 bg-gray-50 border-t border-gray-200 text-center"> {/* Centered text */}
        <p className="text-xs text-gray-600">Sistema profesional de gestión de embarcaciones</p>
      </div>
    </div>
  );
};

export default LoginForm;